import { useFormContext } from "react-hook-form";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import CheckBoxLabelHookForm from "../../../../components/CheckBoxLabelHookForm";
import { useRecoilState, useRecoilValue } from "recoil";
import { officeTypeAddressNotRequired, workFromHome } from "../atoms/atoms";

const OfficeMappingData = ({ disableFields }) => {
  const officeTypeAddressNotRequire = useRecoilValue(
    officeTypeAddressNotRequired
  );
  const [validWorkFrom, setValidWorkFromHome] = useRecoilState(workFromHome);
  const formMethods = useFormContext();
  const officeName = formMethods
    .watch("officeName")
    ?.includes("Work From Home");

  return (
    <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 pb-4">
      <div className="text-quinary font-bold font-sans py-2 px-4">
        Mapping Data (Admin)
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 px-4 gap-12">
        <div className="space-y-1">
          <TextInputHookFormDisabled
            name="shippingAddressLatitude"
            label="Shipping Address Latitude"
            type="text"
            required={true}
            register={formMethods.register("shippingAddressLatitude", {
              required: {
                value: true,
                message: "Required Field",
              },
            })}
            className={
              formMethods.formState.errors.shippingAddressLatitude &&
              "border-2 border-red-500 col-span-2 "
            }
          />
          <TextInputHookFormDisabled
            name="shippingAddressLongitude"
            label="Shipping Address Longitude"
            type="text"
            required={true}
            register={formMethods.register("shippingAddressLongitude", {
              required: {
                value: true,
                message: "Required Field",
              },
            })}
            className={
              formMethods.formState.errors.shippingAddressLongitude &&
              "border-2 border-red-500 col-span-2 "
            }
          />
          <TextInputHookFormDisabled
            name="geolocation"
            label="Geolocation"
            type="text"
            required={true}
            register={formMethods.register("geolocation", {
              required: {
                value: true,
                message: "Required Field",
              },
            })}
            className={
              formMethods.formState.errors.geolocation &&
              "border-2 border-red-500 col-span-2 "
            }
          />

          <TextInputHookFormDisabled
            name="shippingTimeZone"
            label="Shipping Time Zone"
            type="text"
            required={true}
            className={
              formMethods.formState.errors.shippingTimeZone &&
              formMethods.formState.errors.shippingTimeZone.message &&
              "border-2 border-red-500 col-span-2 "
            }
            register={formMethods.register("shippingTimeZone", {
              required: {
                value: true,
                message: "Required Field",
              },
            })}
          />
          <CheckBoxLabelHookForm
            name="shippingDaylightSavings"
            label="Shipping Daylight Savings"
            className="cursor-default pointer-events-none"
            register={formMethods.register}
            onClick={(e) => e.preventDefault()}
          />
        </div>
        <div className="space-y-1">
          <TextInputHookFormDisabled
            name="shippingLastVerified"
            label="Shipping Last Verified"
            type="text"
            register={formMethods.register("shippingLastVerified", {})}
          />

          <TextInputLabelHookForm
            name="shippingReturnCode"
            label="Shipping Return Code"
            type="text"
            register={formMethods.register("shippingReturnCode", {})}
            disabled={disableFields}
          />
          <TextInputHookFormDisabled
            name="shippingCounty"
            label="Shipping County"
            type="text"
            register={formMethods.register("shippingCounty", {})}
          />
        </div>
      </div>
    </div>
  );
};

export default OfficeMappingData;
